export default __webpack_public_path__ + "static/media/sprint-interaction-icon.28a7ad59.svg";